module.exports = __webpack_public_path__ + "img/bf.4c126db0.svg";